import { Injectable, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
//Declaracion de variable para DataTables con jQuery
declare var $: any;


var oldExportAction = function (self, e, dt, button, config) {
	if (button[0].className.indexOf('buttons-excel') >= 0) {
		if ($.fn.dataTable.ext.buttons.excelHtml5.available(dt, config)) {
			$.fn.dataTable.ext.buttons.excelHtml5.action.call(self, e, dt, button, config);
		}else{
			$.fn.dataTable.ext.buttons.excelFlash.action.call(self, e, dt, button, config);
		}
	} else if (button[0].className.indexOf('buttons-print') >= 0) {
		$.fn.dataTable.ext.buttons.print.action(e, dt, button, config);
	}
};

var newExportAction = function (e, dt, button, config) {
	var self = this;
	var oldStart = dt.settings()[0]._iDisplayStart;

	dt.one('preXhr', function (e, s, data) {
		// Just this once, load all data from the server...
		data.start = 0;
		//data.length = 2147483647;
		data.length = -1;

		dt.one('preDraw', function (e, settings) {
			// Call the original action function
			oldExportAction(self, e, dt, button, config);

			dt.one('preXhr', function (e, s, data) {
				// DataTables thinks the first item displayed is index 0, but we're not drawing that.
				// Set the property to what it was before exporting.
				settings._iDisplayStart = oldStart;
				data.start = oldStart;
			});

			// Reload the grid with the original page. Otherwise, API functions like table.cell(this) don't work properly.
			setTimeout(dt.ajax.reload, 0);

			// Prevent rendering of the full data to the DOM
			return false;
		});
	});

	// Requery the server with the new one-time export settings
	dt.ajax.reload();
};

@Injectable()

export class DatatablesService implements OnInit {

  parametrosJsonString : any; //variable para guardar los datos del objeto
  // PATH                    : any = new ConfigService().obtenerPath(); //Path de comunicacion
  //Constructor
  //Se reciben los parametros enviados a traves del constructor
  constructor(
    //parametros : string
  ){
    //Se convierte la cadena a un Json String
    //this.parametrosJsonString = JSON.parse(parametros);
  }

  ngOnInit(): void
  {}

  language(){
    let language = {
      lengthMenu: "Mostrar _MENU_ registros por página.",
      zeroRecords: "No se ha encontrado ningún registro.",
      info: "Mostrando _START_ a _END_ de _TOTAL_ entradas.",
      infoEmpty: "Registros no disponibles.",
      search   : "",
      searchPlaceholder: "Buscar",
      loadingRecords: "Cargando...",
      processing:     "Procesando...",
      paginate: {
        first:      "Primero",
        last:       "Último",
        next:       "Siguiente",
        previous:   "Anterior"
      },
      buttons: {
        pageLength: {
          _: 'Mostrar %d registros'
          ,'-1': "Mostrar todo"
        },
        colvis: 'Visibilidad Columnas'
        ,copy: 'Copiar'
        ,csv: 'CVS'
        ,excel: 'Excel'
        ,pdf: 'PDF'
        ,print: 'Imprimir'
      },
      infoFiltered: "(_MAX_ Registros filtrados en total)"
    };
    return language;
  }

  /*
    var domBftrip = "<'row no-gutters pt-1 px-1'<'col-sm-12 col-md-6 mb-2 mb-md-0'B><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>";
    var domBftri = "<'row no-gutters pt-1 px-1'<'col-sm-12 col-md-6 mb-2 mb-md-0'B><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'tr>><'row'<'col-12'i>>";
    var domlftrip = "<'row no-gutters pt-1 px-1'<'col-sm-6'l><'col-sm-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>";
    var domftrip = "<'row no-gutters pt-1 px-1'<'col-sm-12'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>";
  */

  buttons(title = 'Cocora SM'){
    let buttons = [
      // { extend: 'colvis', text : 'Visualización columnas', columns: ':not(.noVis)'},
      {
        extend: 'excel', action: newExportAction,className: 'excelButton', text: 'Excel',
        title,
        exportOptions: {
          columns: ':not(.noExport)'
        },
      },
      // {
      //   extend: 'copy', className: 'copyButton', text: 'Copiar',
      //   title,
      //   exportOptions: {
      //     columns: [':visible :not(:first-child)']
      //   }
      // },
      // {
      //   extend: 'csv', className: 'csvButton', text: 'CSV',
      //   title,
      //   exportOptions: {
      //     columns: [':visible :not(:first-child)']
      //   }
      // },
      {
        extend: 'pdf', className: 'pdfButton', tex: 'PDF',
        title,
        exportOptions: {
          columns: [':visible :not(:first-child)']
        }
      },
      {
        extend: 'print', className: 'printButton', text: 'Imprimir',
        title : 'Informe',
        exportOptions: {
          columns: [':visible :not(:first-child)']
        }
      },
    ];
    return buttons;
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/datatable/datatables.service.ts